// src/pages/admin/manager/reservas/ReservasManagerLayout.tsx
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Box, Tabs, Tab, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function a11y(label: string, to: string) {
  return {
    id: `tab-${to}`,
    "aria-controls": `panel-${to}`,
    "aria-label": label,
  };
}

export default function ReservasManagerLayout() {
  const { t } = useTranslation<"translation">();
  const loc = useLocation();

  // Detecta tab activo en base a la ruta
  let value = "proyectos";
  if (loc.pathname.includes("/estados")) value = "estados";
  else if (loc.pathname.includes("/proyectos")) value = "proyectos";

  return (
    <Box p={2}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        {t("manager.bookings", "Reservas")}
      </Typography>

      <Stack spacing={2}>
        <Tabs value={value} variant="scrollable" allowScrollButtonsMobile>
          <Tab
            value="proyectos"
            label={t("manager.projects", "Proyectos")}
            component={NavLink}
            to="proyectos"
            {...a11y("Proyectos", "proyectos")}
          />
          <Tab
            value="estados"
            label={t("manager.states", "Estados")}
            component={NavLink}
            to="estados"
            {...a11y("Estados", "estados")}
          />
          {/* En el futuro: más tabs (formatos, reglas…) */}
        </Tabs>

        <Box>
          <Outlet />
        </Box>
      </Stack>
    </Box>
  );
}
